export type ICustomCssHeadContent = {
	addCustomCss: (css: string) => void
	getCustomCss: () => string
}

export type IByocCssHeadContent = {
	addByocCss: (css: string) => void
	getByocCss: () => string
}

export type IGeneralHeadContent = {
	setHead: (content: string, type?: HeadContentType) => void
	getHead: () => string
	getHeadSeoMarkup: () => string
	getHeadMarkupByType: (type: HeadContentType) => string
}

export type IPageCssHeadContent = {
	addPageCss: (css: string) => void
	getPagesCss: () => string
}

export type IScriptPreloadHeadContent = {
	addScriptToPreloadList: (url: string) => void
	getScriptPreloadList: () => Array<string>
}

export type IDomStoreHeadContent = {
	addDomStoreHtml: (html: string) => void
	getDomStoreHtml: () => string
}

export type IHeadContent = IGeneralHeadContent &
	IPageCssHeadContent &
	IScriptPreloadHeadContent &
	Partial<ICustomCssHeadContent> &
	Partial<IByocCssHeadContent> &
	Partial<IDomStoreHeadContent>

export enum HeadContentType {
	SEO = 'seo',
	SEO_DEBUG = 'seo_debug',
	GENERAL = 'general',
}
